// Smart API URL: Use relative URLs when the configured backend URL
// is on a different origin than the current page.
// This avoids CORS issues when using custom domains on Emergent,
// since /api/* is routed to the backend via Kubernetes ingress.
const configured = process.env.REACT_APP_BACKEND_URL || '';
let API_BASE = configured;
try {
  if (configured && typeof window !== 'undefined') {
    const cfgOrigin = new URL(configured).origin;
    if (cfgOrigin !== window.location.origin) {
      API_BASE = '';
    }
  }
} catch {
  API_BASE = '';
}
export default API_BASE;
